module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invite-box text-center"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('MyInvitationCode')))]), _vm._v(" "), _c('div', {
    staticClass: "invite-info"
  }, [_c('p', {
    staticClass: "invite-code"
  }, [_vm._v(_vm._s(_vm.$t('invitationCode')) + "："), _c('span', [_vm._v(_vm._s(_vm.invitationCode))])]), _vm._v(" "), _c('invite-url', {
    staticClass: "invite-url-component",
    attrs: {
      "invitation-code": _vm.invitationCode
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "describe"
  }, [_vm._v(_vm._s(_vm.$t('explain')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9953aeaa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inviteFriend/InviteFriend.vue
// module id = 1372
// module chunks = 1